import React, {useState} from 'react'
import {Card, Col, Row, Space, Table, Tag, Collapse} from "antd";
import {purchaseCostReports} from "../../services/serviceReports";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import PurchaseCostFilter from "./PurchaseCostFilter";
import Filter from "../filterWrapper/Filter";
import {SearchOutlined} from "@ant-design/icons";
import LineChart from "../charts/LineChart";
import BarChart from "../charts/BarChart";
import { groupSubItemsByMultiField } from '../../utils/helpers/commonFunctions';
import RecipeDetail from '../recipe/details/RecipeDetails';

const setTableRowKeys = (r, index) => index
const {Panel} = Collapse;

const PurchaseCostReports = () => {
    const [tableData, setTableData] = useState({});
    const [openFilter, setOpenFilter] = useState(false);

    const handleClear = () => setTableData([]);
    const toggleFilterDisplay = () => setOpenFilter(!openFilter);

    const offerColumns = [
        {title: 'Oluşturma Tarihi', dataIndex: 'cd', render: (t) => userDateFormatter(t)},
        {title: 'Tekli No', dataIndex: 'bn'},
        {title: 'Müşteri', dataIndex: 'cn'},
        {title: 'Miktar', dataIndex: 'a'},
        {title: 'Birim Fiyatı', dataIndex: 'lp'},
        {title: 'İskonto Dahil Fiyat', dataIndex: 'z', render: (t) => new Intl.NumberFormat().format(t)},
        {title: 'İskonto 1', dataIndex: 'd', render: (t) => Number(t) === 0 ? '' : t},
        {title: 'İskonto 2', dataIndex: 'd2', render: (t) => Number(t) === 0 ? '' : t},
        {title: 'Para Birimi', dataIndex: 'cr'},
        {title: 'Satır Toplamı', dataIndex: 'lt'},
    ];
    const purchaseColumns = [
        {title: 'Oluşturma Tarihi', dataIndex: 'cd', render: (t) => userDateFormatter(t)},
        {title: 'Satın Alma No', dataIndex: 'pn'},
        {title: 'Tedarikçi', dataIndex: 'sn'},
        {title: 'Miktar', dataIndex: 'q'},
        {title: 'Birim Fiyatı', dataIndex: 'lp'},
        {title: 'Para Birimi', dataIndex: 'cr'},
        {title: 'Satır Toplamı', dataIndex: 'lt'},
    ];
    const recipeColumns = [
        {title: 'Stok Kodu', dataIndex: 'c'},
        {title: 'Stok Adı', dataIndex: 'sn'},
        {title: 'Birim Fiyatı', dataIndex: 'up'},
        {title: 'Parite', dataIndex: 'p'},
        {title: 'Para Birimi', dataIndex: 'cr'},
        {title: 'Satır Toplamı', dataIndex: 'lt'},
        {title: 'Miktar', dataIndex: 'a'},
    ];
    const gainLossColumns = [
        {title: 'Satın Alma No', dataIndex: 'p'},
        {title: 'Teklif No', dataIndex: 'b'},
        {title: 'Kar/Zarar Oranı', dataIndex: 't', render: (t) => Number(t) > 0 ? <Tag color={'green'}>{t}</Tag> : <Tag color={'red'} >{t}</Tag>}
    ];

    const handleFilter = (...filterData) => {
        purchaseCostReports(filterData[0])
            .then(({data}) => {
                if(data.purchaseDTOList && data.purchaseDTOList.length > 1) {
                    const grouped = groupSubItemsByMultiField('cr', 'pn', data.purchaseDTOList, ['lp', 'lt', 'q']);
                    data.purchaseDTOList = [...grouped];
                }
                setTableData(data);
            })

        return new Promise((resolve, reject) => {
            resolve(true);
            reject(false);
        })
    };

    return(
        <React.Fragment>
            <Card
                title={'Satın Alma Maliyet Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row justify={"start"}>
                        <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                    </Row>
                    <Collapse accordion defaultActiveKey={['0']}>
                        <Panel header={'Teklif Bazlı'} key={'0'}>
                            {
                                tableData.bidDTOList && tableData.bidDTOList.length
                                    ?      <Row>
                                        <Col span={12}>
                                            <LineChart
                                                xAxis={tableData.bidDTOList.slice(0, 20).map(item => item.lp)}
                                                yAxis={tableData.bidDTOList.slice(0, 20).map(item => item.a)}
                                                xSet={'Birim Fiyat'}
                                                ySet={'Miktar'}
                                                label={'Son 20'}
                                            />
                                        </Col>
                                    </Row>
                                    : null
                            }
                            <Table rowKey={setTableRowKeys} columns={offerColumns} dataSource={tableData.bidDTOList}/>
                        </Panel>
                        <Panel header={'Satın Alma Bazlı'} key={'1'}>
                            <Table rowKey={setTableRowKeys} columns={purchaseColumns} dataSource={tableData.purchaseDTOList}/>
                        </Panel>
                        <Panel header={'Reçete Bazlı'} key={'2'}>
                            {
                                tableData.recipeDTOList?.length ?
                                    <RecipeDetail recipeId={tableData.recipeDTOList[0].rid}/>
                                    : null
                            }
                            <Table rowKey={setTableRowKeys} columns={recipeColumns} dataSource={tableData.recipeDTOList}/>
                        </Panel>
                        <Panel header={'Kar/Zarar'} key={'3'}>
                            {
                                tableData.gainOrLossDTOS && tableData.gainOrLossDTOS.length
                                    ?  <Row>
                                        <Col span={12}>
                                            <BarChart
                                                xAxis={tableData.gainOrLossDTOS.slice(0, 10).map(item => item.b)}
                                                yAxis={tableData.gainOrLossDTOS.slice(0, 10).map(item => item.t)}
                                                label={'Son 10'}
                                            />
                                        </Col>
                                    </Row>
                                    : null
                            }
                            <Table rowKey={setTableRowKeys} columns={gainLossColumns} dataSource={tableData.gainOrLossDTOS}/>
                        </Panel>
                    </Collapse>
                </Space>
            </Card>

            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Marka Bazlı Teklif Raporlama'}
                    handler={handleFilter}
                    resetHandler={handleClear}
                >
                   <PurchaseCostFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default PurchaseCostReports